/**
 * @function closest
 * @memberof Promega.Util
 * @description Searches up the tree for a parent that matches the given selector, returning it (if found)
 * @deprecated Use native Element.closest instead
 * @param {HTMLElement} el Any HTML element
 * @param {String} selector The CSS selector for which to search
 * @returns {HTMLElement} The closest matching element in the parent chain, or <code>null</code> if there is no match
 */
export default function closest(el, selector) {
    return el.closest(selector);
}
